module.exports = __webpack_public_path__ + "static/media/seer-host.5f393959.gif";